import React from 'react';

export default class Page1 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="innovativeimg">
                                            <img alt=""
                                                 src={require('@images/how to communicate effectively.png')}/>
                                        </div>

                                        <div className="ilead-contentarea">

                                            <div className="circle_title"><img
                                                src={require('@images/browndot.jpg')}
                                                alt=""/>isn't it interesting?</div>
                                            <p>Christmas this year is cancelled…</p>
                                            <div className="border_subtitle">What type of communication do you
                                                respond to?
                                            </div>
                                            <p>Consider adverts at Christmas that aim to prevent or reduce how
                                                much alcohol people drink before they drive, or appeal for
                                                donations to charities. When you see these adverts, do you
                                                listen carefully to the message? Or do you swiftly change the
                                                channel? Clearly some of these adverts succeed and people’s
                                                behaviours change, but there are many different ways to
                                                communicate messages and these vary depending on the audience’s
                                                needs.</p>

                                            <div className="lightgreencontentbg keyquestionpad">
                                                <div className="border_subtitle">Shock adverts – do they work?
                                                </div>
                                                <p>The bottom line in advertising is that producers want to
                                                    clearly communicate a message to the audience. This applies
                                                    to adverts selling products as well as messages to encourage
                                                    positive behaviour such as health awareness.</p>
                                                <p>A modern study<a className="superscripttext"
                                                                    href="further_info.php?course=300"><sup>1</sup></a> researched
                                                    the effectiveness of public health adverts in encouraging
                                                    people to perform health self-examinations. Adverts which
                                                    induced high, low or no levels of fear had varying levels of
                                                    success on those who viewed the adverts, but it was not the
                                                    only dependent factor. What was found to be more important
                                                    was the level of subjective knowledge about the health
                                                    issues that the individuals already had. In essence, the
                                                    level of influence achieved by the advert depended on the
                                                    person who was watching it.</p>
                                                <p>A similar study<a className="superscripttext"
                                                                     href="further_info.php?course=300"><sup>2</sup></a> showed
                                                    how other factors, such as gender, can cause different
                                                    effects. The study involved anti-speeding adverts, and while
                                                    females believed the adverts would affect themselves more
                                                    than others, men believed the opposite (it would affect
                                                    others more than themselves.) As a result, females reported
                                                    that they were more likely to change their behaviour than
                                                    men were.</p>
                                            </div>

                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    ;
    }
    }